import React from 'react';

import Reveal from '../ui/Reveal';
import './pillars.scss';

const DataIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="15" stroke="currentColor" strokeWidth="3" />
    <path d="M14 24h20M24 14v20" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const DevIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <path
      d="M17 15L7 24l10 9M31 15l10 9-10 9M27 12l-6 24"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AiIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="6" stroke="currentColor" strokeWidth="3" />
    <circle cx="8" cy="12" r="4" stroke="currentColor" strokeWidth="3" />
    <circle cx="40" cy="12" r="4" stroke="currentColor" strokeWidth="3" />
    <circle cx="8" cy="36" r="4" stroke="currentColor" strokeWidth="3" />
    <circle cx="40" cy="36" r="4" stroke="currentColor" strokeWidth="3" />
    <path
      d="M18.5 20L11 15M29.5 20L37 15M18.5 28L11 33M29.5 28L37 33"
      stroke="currentColor"
      strokeWidth="2.5"
    />
  </svg>
);

const PILLARS = [
  {
    tag: '01 / DATA',
    title: 'Data',
    Icon: DataIcon,
    blurb: 'Turn scattered spreadsheets and disconnected tools into one source of truth.',
    items: ['BI dashboards & reporting', 'Data engineering & pipelines', 'Warehouse & analytics setup'],
  },
  {
    tag: '02 / DEV',
    title: 'Dev',
    Icon: DevIcon,
    blurb: 'Ship the software your business actually needs — not a bloated off-the-shelf fit.',
    items: ['Custom web & internal tools', 'Systems integration & APIs', 'Product & MVP development'],
  },
  {
    tag: '03 / AI',
    title: 'AI',
    Icon: AiIcon,
    blurb: "Put automation and AI agents to work on the tasks eating your team's week.",
    items: ['Workflow & process automation', 'AI agents & LLM integrations', 'Internal copilots & assistants'],
  },
];

export default function PillarsSection() {
  return (
    <section className="section pillars-section" id="pillars">
      <div className="wrap">
        <Reveal className="section-head">
          <p className="eyebrow">What we build</p>
          <h2>Three disciplines, one senior team.</h2>
          <p>
            Most agencies specialize in one lane. We run data, software and AI as one connected
            practice — because in a small or mid-size business, they rarely come apart.
          </p>
        </Reveal>

        <div className="pillars">
          {PILLARS.map((pillar, index) => (
            <Reveal key={pillar.title} delay={index * 90} className="pillar-shell">
              <article className="pillar">
                <span className="pillar__tag">{pillar.tag}</span>
                <span className="pillar__icon">
                  <pillar.Icon />
                </span>
                <h3>{pillar.title}</h3>
                <p>{pillar.blurb}</p>
                <ul>
                  {pillar.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
